enum PaymentMethodProviderType {
    Api = 'PAYMENT_TYPE_API',
    Hosted = 'PAYMENT_TYPE_HOSTED',
    Offline = 'PAYMENT_TYPE_OFFLINE',
    PPSDK = 'PAYMENT_TYPE_SDK',
}

export default PaymentMethodProviderType;
